export default "__VITE_ASSET__DJ8i20rl__"